package io.jsonize.web.screens.editor

enum class EditorPanel {
    Editor,
    History,
    Preview
}
